module.exports = __webpack_public_path__ + "static/media/html.24845c5c.svg";